import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
  private isCheckingAuth = false;

  constructor() {
    // Initialize with current authentication state
    this.checkAuthState();
  }

  checkAuthState(): void {
    // Prevent multiple simultaneous checks
    if (this.isCheckingAuth) {
      return;
    }
    
    this.isCheckingAuth = true;
    
    const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    const rememberMe = localStorage.getItem('remember_me') === 'true';
    
    console.log('🔍 [AUTH-STATE] checkAuthState() called');
    console.log('🔍 [AUTH-STATE] Token found:', !!token);
    console.log('🔍 [AUTH-STATE] Remember me:', rememberMe);
    console.log('🔍 [AUTH-STATE] localStorage token:', !!localStorage.getItem('auth_token'));
    console.log('🔍 [AUTH-STATE] sessionStorage token:', !!sessionStorage.getItem('auth_token'));
    
    let isAuthenticated = false;
    if (token) {
      // Check both storage locations regardless of remember me setting
      const localToken = !!localStorage.getItem('auth_token');
      const sessionToken = !!sessionStorage.getItem('auth_token');
      isAuthenticated = localToken || sessionToken;
      
      // Additional validation: check if token is not expired
      const expirationTime = rememberMe ? 
        localStorage.getItem('token_expiration') : 
        sessionStorage.getItem('token_expiration');
      
      if (expirationTime && new Date().getTime() > parseInt(expirationTime)) {
        console.log('🔍 [AUTH-STATE] Token expired, clearing authentication');
        this.clearAuthData();
        isAuthenticated = false;
      }
    }
    
    console.log('🔍 [AUTH-STATE] Is authenticated result:', isAuthenticated);
    this.isAuthenticatedSubject.next(isAuthenticated);
    this.isCheckingAuth = false;
  }

  setAuthenticated(authenticated: boolean): void {
    console.log('🔍 [AUTH-STATE] setAuthenticated() called with:', authenticated);
    
    // Only update if the state is actually changing
    if (this.isAuthenticatedSubject.value !== authenticated) {
      this.isAuthenticatedSubject.next(authenticated);
      
      // If setting to false, ensure we check again in case of inconsistent state
      if (!authenticated) {
        setTimeout(() => {
          this.checkAuthState();
        }, 100);
      }
    }
  }

  private clearAuthData(): void {
    // Clear all authentication data
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    localStorage.removeItem('remember_me');
    localStorage.removeItem('token_expiration');
    sessionStorage.removeItem('auth_token');
    sessionStorage.removeItem('auth_user');
    sessionStorage.removeItem('token_expiration');
  }
} 